export default "__VITE_ASSET__Bm8TSUcH__"